import { differenceInDays, format, parseISO } from 'date-fns';
import { toCurrency, unmaskMoney } from '../../../normalizers/normalize';
import DADOS_SIM from './../../../consts/consts';
import ENUM from './../../../consts/enum';

const listaBemValues = DADOS_SIM.LISTA_BENS;
const conteudoValues = DADOS_SIM.CONTEUDO;
const questionarioValues = DADOS_SIM.QUESTIONARIO_RESPOSTAS;

export const setObjectEnvioSession = (
    cotacao,
    listaBens,
    nomeTipoVigencia,
    inicioVigencia,
    fimVigencia,
    numeroApoliceAnterior
) => {
    let listaBensEnvio = [];
    let listaBensSession = [];
    // Percorre o array de Bens para criar uma nova Lista de Bens para enviar para o Backend
    // Modifica o objeto criado para converter os valores monetários para float para o envio
    listaBens.forEach((bem) => {
        let bemEnvio = {
            [listaBemValues.ID]: bem[listaBemValues.ID],
            [listaBemValues.VALOR_UNITARIO_BEM]: parseFloat(
                unmaskMoney(bem[listaBemValues.VALOR_UNITARIO_BEM].toString())
            ),
            [listaBemValues.QUANTIDADE]: bem[listaBemValues.QUANTIDADE]
                ? parseInt(bem[listaBemValues.QUANTIDADE])
                : null,
            [listaBemValues.ANO]: bem[listaBemValues.ANO],
            [listaBemValues.ID_BEM]: bem[listaBemValues.ID_BEM],
            [listaBemValues.ID_TIPO_BEM]: bem[listaBemValues.ID_TIPO_BEM],
            [listaBemValues.ID_TIPO_CONSTRUCAO]: bem[listaBemValues.ID_TIPO_CONSTRUCAO],
            [listaBemValues.GARANTIA]: bem[listaBemValues.GARANTIA],
            [listaBemValues.QUESTIONARIO_RESPOSTAS]: bem[listaBemValues.QUESTIONARIO_RESPOSTAS].map((pergunta) => {
                if (pergunta[questionarioValues.RESPOSTA] !== null) {
                    return pergunta;
                } else return null;
            }),
            [listaBemValues.COBERTURAS_PERSONALIZADO]: null
        };

        let bemSession = {
            ...bem,
            [listaBemValues.VALOR_UNITARIO_BEM]: bem[listaBemValues.VALOR_UNITARIO_BEM]
        };

        if (bem[conteudoValues.VALOR_TOTAL]) {
            bemEnvio = {
                ...bemEnvio,
                [conteudoValues.VALOR_TOTAL]: parseFloat(unmaskMoney(bem[conteudoValues.VALOR_TOTAL].toString()))
            };

            bemSession = {
                ...bemSession,
                [conteudoValues.VALOR_TOTAL]: bem[conteudoValues.VALOR_TOTAL].toString()
            };
        }

        // Verifica se o tipo de Bem possui lista de conteudo
        // Caso possua percorre os itens da lista para converter os valores monetarios para float
        if (bem[listaBemValues.COTACAO_CONTEUDO] && bem[listaBemValues.COTACAO_CONTEUDO].length > 0) {
            let listaConteudoEnviado = [];
            let listaConteudoSession = [];

            bem[listaBemValues.COTACAO_CONTEUDO].forEach((conteudo) => {
                let conteudoEnviado = {
                    [conteudoValues.ID_CONTEUDO]: conteudo[conteudoValues.ID_CONTEUDO],
                    [conteudoValues.QUANTIDADE]: parseFloat(conteudo[conteudoValues.QUANTIDADE]),
                    [conteudoValues.VALOR_UNITARIO_CONTEUDO]: parseFloat(
                        unmaskMoney(conteudo[conteudoValues.VALOR_UNITARIO_CONTEUDO].toString())
                    ),
                    [conteudoValues.VALOR_TOTAL]: parseFloat(
                        unmaskMoney(conteudo[conteudoValues.VALOR_TOTAL].toString())
                    )
                };

                listaConteudoSession.push(conteudo);
                listaConteudoEnviado.push(conteudoEnviado);
            });

            bemEnvio = {
                ...bemEnvio,
                [listaBemValues.COTACAO_CONTEUDO]: listaConteudoEnviado
            };

            bemSession = {
                ...bemSession,
                [listaBemValues.COTACAO_CONTEUDO]: listaConteudoSession
            };
        }

        bemSession = {
            ...bemSession,
            [listaBemValues.TIPO_BEM]: bem[listaBemValues.TIPO_BEM]
        };

        listaBensEnvio.push(bemEnvio);
        listaBensSession.push(bemSession);
    });

    let objEnvio;

    objEnvio = {
        [listaBemValues.CODIGO_COTACAO]: cotacao[listaBemValues.CODIGO_COTACAO],
        bens: listaBensEnvio,
        [listaBemValues.TIPO_VIGENCIA]: nomeTipoVigencia,
        [listaBemValues.DATA_INICIO_VIGENCIA]: inicioVigencia ? format(inicioVigencia, 'yyyy-MM-dd') : null,
        [listaBemValues.DATA_FIM_VIGENCIA]: fimVigencia ? format(fimVigencia, 'yyyy-MM-dd') : null,
        numeroApoliceAnterior: numeroApoliceAnterior
    };

    let tempoVigencia;

    if (nomeTipoVigencia === ENUM.VIGENCIA.SELETIVA) {
        inicioVigencia = parseISO(format(inicioVigencia, 'yyyy-MM-dd'));
        fimVigencia = parseISO(format(fimVigencia, 'yyyy-MM-dd'));
        tempoVigencia = differenceInDays(fimVigencia, inicioVigencia) + ' dias';
    } else {
        inicioVigencia = null;
        fimVigencia = null;
        tempoVigencia = null;
    }

    let objSession = {
        [listaBemValues.CODIGO_COTACAO]: cotacao[listaBemValues.CODIGO_COTACAO],
        [listaBemValues.TIPO_VIGENCIA]: nomeTipoVigencia,
        listaBens: listaBensSession,
        [listaBemValues.DATA_INICIO_VIGENCIA]: inicioVigencia,
        [listaBemValues.DATA_FIM_VIGENCIA]: fimVigencia,
        [listaBemValues.TEMPO_VIGENCIA]: tempoVigencia,
        numeroApoliceAnterior: numeroApoliceAnterior
    };

    return { objEnvio, objSession };
};

export const verificaErroPreenchimentoVigencia = (inicioVigencia, fimVigencia, tipoVigencia) => {
    let msgErro = {};
    let error = false;

    if (tipoVigencia && tipoVigencia === 'Seletiva' && (!inicioVigencia || !fimVigencia)) {
        msgErro = 'É necessário selecionar uma data';
        error = true;
    }
    return { error, msgErro };
};

export function verifyStatusBar(bemSelecionado) {
    const respostasValidas = bemSelecionado[listaBemValues.QUESTIONARIO_RESPOSTAS].filter(
        (pergunta) => pergunta[questionarioValues.RESPOSTA] !== null
    );
    const respConteudo = respostaConteudo(bemSelecionado[listaBemValues.QUESTIONARIO_RESPOSTAS]);

    const idTipoBem = bemSelecionado[listaBemValues.ID_TIPO_BEM];
    if (
        respostasValidas.length === bemSelecionado[listaBemValues.QUESTIONARIO_RESPOSTAS].length &&
        respostasValidas.length !== 0
    ) {
        if (idTipoBem === ENUM.TIPO_BEM.BENFEITORIA) {
            if (respConteudo && respConteudo[questionarioValues.RESPOSTA]) {
                const conteudos = bemSelecionado[listaBemValues.COTACAO_CONTEUDO];
                if (conteudos && conteudos.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
    } else if (
        bemSelecionado[listaBemValues.QUESTIONARIO_RESPOSTAS] &&
        bemSelecionado[listaBemValues.QUESTIONARIO_RESPOSTAS].length === 0
    ) {
        return true;
    } else {
        return false;
    }
}

function respostaConteudo(respostas) {
    return respostas.find((res) => res[questionarioValues.ID_REDIS] === ENUM.RESPOSTA_CONTEUDO);
}

export const mapBens = (bens) =>
    bens.map((bem) => ({
        ano: bem.ano,
        cotacaoConteudos: bem.conteudos,
        id: bem.id,
        idBem: bem.idBem,
        idTipoBem: bem.tipoBem && bem.tipoBem.idTipoBem,
        tipoBem: bem.tipoBem && bem.tipoBem.tipoBem,
        inGarantia: bem.inGarantia,
        nomeBem: bem.nomeBem,
        valorUnitario: toCurrency(bem.valorUnitario),
        idTipoConstrucao: bem.tipoConstrucao && bem.tipoConstrucao.idTipoConstrucao,
        tipoConstrucao: bem.tipoConstrucao && bem.tipoConstrucao.tipoConstrucao,
        questionarioRespostas:
            bem.questionarios &&
            bem.questionarios.map((questionario) => ({
                idQuestionario: questionario.idQuestionario,
                idRedis: questionario.id,
                mensagemErro: questionario.mensagemErro,
                pergunta: questionario.descricao,
                recusa: questionario.recusa,
                resposta: questionario.resposta,
                respostaRecusa: questionario.resposta
            })),
        statusRectangleColor: '#48d53a',
        isCollapse: false,
        iconNameCollapse: 'angle double down'
    }));
